import { ADMIN_ROUTES } from 'constants/routes';
import { PERMISSIONS } from 'constants/permissions';

type TypeOfEntityType =
  | 'BRAND'
  | 'CLIENT'
  | 'SUPPLIER'
  | 'ITEM'
  | 'COUNTRY'
  | 'LEAD'
  | 'DEAL'
  | 'PURCHASE_REQUEST'
  | 'ORDER'
  | 'PURCHASE_ORDER'
  | 'SALES'
  | 'SUPPLY_ORDER'
  | 'DELIVERY_ORDER';

export const AllEntityTypes: Record<
  string,
  { label: string; value: TypeOfEntityType; path: string; disabled?: boolean; tab?: string; permission?: string }
> = {
  BRAND: {
    label: 'Brand',
    value: 'BRAND',
    path: ADMIN_ROUTES.brand.view,
    tab: ADMIN_ROUTES.brand.management,
    permission: PERMISSIONS.brands.brand.read,
  },
  CLIENT: {
    label: 'Client',
    value: 'CLIENT',
    path: ADMIN_ROUTES.client,
    tab: ADMIN_ROUTES.clientGeneral,
    permission: PERMISSIONS.clients.client.read,
  },
  SUPPLIER: {
    label: 'Supplier',
    value: 'SUPPLIER',
    path: ADMIN_ROUTES.suppliers.view,
    tab: ADMIN_ROUTES.suppliers.general,
    permission: PERMISSIONS.suppliers.supplier.read,
  },
  COUNTRY: {
    label: 'Country',
    value: 'COUNTRY',
    path: ADMIN_ROUTES.country.view,
    tab: ADMIN_ROUTES.country.management,
    permission: PERMISSIONS.countries.country.read,
  },
  ITEM: {
    label: 'Item',
    value: 'ITEM',
    path: ADMIN_ROUTES.items.view,
    tab: ADMIN_ROUTES.items.suppliers,
    permission: PERMISSIONS.items.item.read,
  },
  LEAD: {
    label: 'Lead',
    value: 'LEAD',
    path: ADMIN_ROUTES.leads.view,
    tab: ADMIN_ROUTES.leads.general,
    permission: PERMISSIONS.leads.lead.read,
  },
  DEAL: {
    label: 'Deal',
    value: 'DEAL',
    path: ADMIN_ROUTES.deals.view,
    tab: ADMIN_ROUTES.deals.purchaseRequest,
    permission: PERMISSIONS.deals.deal.read,
  },
  PURCHASE_REQUEST: {
    label: 'Purchase Request',
    value: 'PURCHASE_REQUEST',
    path: ADMIN_ROUTES.purchaseRequest.view,
    tab: ADMIN_ROUTES.purchaseRequest.general,
    permission: PERMISSIONS.purchaseRequests.purchaseRequest.read,
  },
  ORDER: {
    label: 'Order',
    value: 'ORDER',
    path: ADMIN_ROUTES.orders.view,
    tab: ADMIN_ROUTES.orders.general,
    permission: PERMISSIONS.orders.order.read,
  },
  PURCHASE_ORDER: {
    label: 'Purchase Order',
    value: 'PURCHASE_ORDER',
    path: ADMIN_ROUTES.purchaseOrder.view,
    tab: ADMIN_ROUTES.purchaseOrder.general,
    permission: PERMISSIONS.purchaseOrders.purchaseOrder.read,
  },
  SALES: { label: 'Sales', value: 'SALES', path: '', disabled: true },
  SUPPLY_ORDER: { label: 'Supply Order', value: 'SUPPLY_ORDER', path: '', disabled: true },
  DELIVERY_ORDER: { label: 'Delivery Order', value: 'DELIVERY_ORDER', path: '', disabled: true },
};

export const StatusTypes = [
  { value: 'TODO', label: 'To Do' },
  { value: 'IN_PROGRESS', label: 'In Progress' },
  { value: 'REOPENED', label: 'Reopened' },
  { value: 'DONE', label: 'Done' },
];
export const PriorityTypes = [
  { value: 'HIGH', label: 'High' },
  { value: 'STANDARD', label: 'Standard' },
  { value: 'LOW', label: 'Low' },
];

export const ChangeStatusMapping: Record<any, any> = {
  TODO: [
    { value: 'IN_PROGRESS', label: 'In Progress' },
    { value: 'DONE', label: 'Done' },
  ],
  REOPENED: [
    { value: 'IN_PROGRESS', label: 'In Progress' },
    { value: 'DONE', label: 'Done' },
  ],
  IN_PROGRESS: [
    { value: 'DONE', label: 'Done' },
    { value: 'TODO', label: 'To Do' },
  ],
  DONE: [{ value: 'REOPENED', label: 'Reopened' }],
};

type Task = {
  id: string;
  uuid: string | number;
  name: string;
  summary: string;
  assignedTo: string;
  priorityLevel: string;
  entityType: string;
  entityId: string;
  entityUuid: string | number;
  entityValue: string;
  status: string;
  createdBy: string;
  _createdBy?: Record<string, any>;
  dueDate: string;
  createDate: string;
  lastModifiedDate: string;
};

type CommentUser = {
  files?: {
    AVATAR?: string;
  };
  userName: string;
  firstName: string;
  lastName: string;
  id: string;
};

export type Comment = {
  lastModifiedDate: string;
  createDate: string;
  id: string;
  entityId: string;
  entityName: string;
  userId: string;
  firstName: string;
  lastName: string;
  title: string;
  user: CommentUser;
};

export type { Task, TypeOfEntityType };
